import React from 'react'
import img105a from './images/sl1.jpeg'
import img105b from './images/sl2.jpeg'
import img105c from './images/sl3.jpeg'
import img105d from './images/sl4.jpeg'
import img105e from './images/sl5.jpeg'
import img105f from './images/sl6.jpeg'
import img105g from './images/sl7.jpeg'
import img105h from './images/sl8.jpeg'
import img105i from './images/sl9.jpeg'
import img105j from './images/sl10.jpeg'
import img105k from './images/sl11.jpeg'
import img105l from './images/sl12.jpeg'
import img105m from './images/sl13.jpeg'
import img105n from './images/sl14.jpeg'

const events = () => {
    return (

        <>
            {/* <div id="carouselExample" className="carousel slide carousel-fade">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <video className="img-fluid" autoplay loop muted>
                            <source src="https://mdbcdn.b-cdn.net/img/video/Tropical.mp4" type="video/mp4" />
                        </video>
                    </div>
                </div>
            </div> */}


            <div className="row  m-2">
                <h2 className='text-white text-center bg-dark p-3'>Events Gallery</h2>
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={img105a} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4" 
                    />

                    <img
                        src={img105b} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={img105c} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    <img
                         src={img105d} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                         src={img105e} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    {/* <img
                         src={img105f} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    /> */}
                </div>
                 <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                         src={img105g} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    <img
                         src={img105h} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>
                 <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                         src={img105i} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    <img
                         src={img105j} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>
                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                         src={img105k} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    <img
                         src={img105l} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>
                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                         src={img105m} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />

                    <img
                         src={img105n} alt="Queryimg"
                        className="w-100 shadow-1-strong rounded mb-4"
                       
                    />
                </div>
            </div>

        </>
    )
}

export default events
